import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ChipModule } from '@libs/src/chip/chip.module';

import { GroupSegmentsChipsComponent } from './group-segments-chips.component';

@NgModule({
  declarations: [GroupSegmentsChipsComponent],
  exports: [GroupSegmentsChipsComponent],
  imports: [ChipModule, CommonModule, FlexLayoutModule],
})
export class GroupSegmentsChipsModule {}
